import { Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";

interface FieldRowProps {
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  field: React.ReactNode;
  caption?: string | React.ReactNode;
}

export const FieldRow = (props: FieldRowProps) => {
  const { title, subtitle, field, caption } = props;

  return (
    <>
      <Grid item xs={12} md={6}>
        {typeof title === "string" ? (
          <Typography display="block">{title}</Typography>
        ) : (
          title
        )}
        {subtitle && typeof subtitle === "string" && (
          <Typography
            variant="caption"
            color="textSecondary"
            display={caption ? "block" : "inline"}
          >
            {subtitle}
          </Typography>
        )}
        {subtitle && typeof subtitle !== "string" && subtitle}
        {caption && typeof caption === "string" && (
          <Typography variant="mini" color="textSecondary">
            {caption}
          </Typography>
        )}
        {caption && typeof caption !== "string" && caption}
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        {field}
      </Grid>
    </>
  );
};
